// extracted by mini-css-extract-plugin
export default {"subtitle":"Button_subtitle__zn9KU","button":"Button_button__omVtL","primary":"Button_primary__KPIMa","secondary":"Button_secondary__lyQMI"};